import { LuTrendingDown, LuTrendingUp } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { ChartRendererProps } from '../../types/chart-renderer-props';
import { formatDurationTrendChange, toDurationMetric, toDurationParts } from '../../utils/to-duration-metric';
import { DurationMetricLabel } from './duration-metric-label.component';

const trendClassName = (direction: 'up' | 'down' | 'flat'): string => {
    if (direction === 'down') {
        return 'text-status-success';
    }

    if (direction === 'up') {
        return 'text-status-warning';
    }

    return 'text-brand-muted';
};

export const DurationMetricChart = ({ data, className }: ChartRendererProps) => {
    const metric = toDurationMetric(data);

    if (!metric) {
        return null;
    }

    return (
        <div className={`flex w-full items-end justify-between gap-3 ${className ?? ''}`}>
            <div className='flex min-w-0 flex-col items-start justify-end gap-0.5'>
                <div className='text-brand-muted justify-start text-sm font-medium'>
                    <FormattedMessage
                        id='chart.components.renderers.duration-metric-chart.average-abbreviation'
                        description='Abbreviated label for the average duration value on a transaction timer duration metric chart'
                        defaultMessage='Avg.'
                    />
                </div>
                <div className='text-foreground-default justify-start text-xl font-semibold'>
                    <DurationMetricLabel {...toDurationParts(metric.averageSeconds)} />
                </div>
            </div>
            {metric.minuteChange !== null && (
                <div className={`flex shrink-0 items-center gap-1 text-base font-semibold ${trendClassName(metric.direction)}`}>
                    {metric.direction === 'down' && <LuTrendingDown className='size-5' />}
                    {metric.direction === 'up' && <LuTrendingUp className='size-5' />}
                    <span>{formatDurationTrendChange(metric.minuteChange, metric.percentChange)}</span>
                </div>
            )}
        </div>
    );
};
